import { CSSProperties } from 'react';

// Base font size (rem) of the sample specimen. Multiplied by the chosen scale
// so the preview grows/shrinks exactly as the on-felt text does.
const SAMPLE_BASE_REM = 1.1;

/**
 * Live text-size sample for the "Table View Size" setting. Shows a general text
 * specimen ("This will be the text size") at the currently-selected scale so the player can see how
 * large the on-felt text will be before leaving Settings. Pure/presentational —
 * the scale is passed in from TableSettings.
 */
const TableViewSizePreview = ({ scale }: { scale: number }) => {
  const s = Number.isFinite(scale) && scale > 0 ? scale : 1;
  return (
    <div style={previewBox}>
      <span style={previewCaption}>Preview</span>
      <span
        data-testid='table-view-size-sample'
        style={{ ...previewSample, fontSize: `calc(${SAMPLE_BASE_REM}rem * ${s})` }}>
        This’ll be the text size, y’all.
      </span>
    </div>
  );
};

export default TableViewSizePreview;

const previewBox: CSSProperties = {
  marginTop: 10,
  padding: '10px 12px',
  borderRadius: 8,
  background: 'rgba(0, 0, 0, 0.28)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  gap: 6
};

const previewCaption: CSSProperties = {
  fontSize: '0.55rem',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'rgba(255, 255, 255, 0.35)'
};

// A neutral, readable specimen — represents general on-felt text size.
const previewSample: CSSProperties = {
  fontWeight: 700,
  color: 'rgba(255, 255, 255, 0.9)',
  lineHeight: 1.1,
  letterSpacing: '0.01em'
};
